/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Pos_Order_CodeInputs */

const vi_pos_order_code = /** @type {(inputs: Pos_Order_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mã đơn: ${i?.code}`)
};

/**

* @param {Pos_Order_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_order_code = /** @type {((inputs: Pos_Order_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Order_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_order_code(inputs)
});